"use client";

import { io, Socket } from "socket.io-client";

import { env } from "@/env";
import { Chat, Message } from "@/types";
import { CookiesService } from "@/utils";

interface ServerToClientEvents {
  "message-created": (message: Message) => void;
  "chat-deleted": ({ chatId }: { chatId: Chat["id"] }) => void;
  "block-created": ({
    blockedByUserId,
    blockedUserId,
    affectedChatId,
  }: {
    blockedByUserId: string;
    blockedUserId: string;
    affectedChatId: string;
  }) => void;
  "block-deleted": ({
    blockedByUserId,
    blockedUserId,
    affectedChatId,
  }: {
    blockedByUserId: string;
    blockedUserId: string;
    affectedChatId: string;
  }) => void;
  "message-updated": ({
    isDeletedChanged,
    isEditedChanged,
    isReadByMeChanged,
    isReadChanged,
    message,
    unreadMessages,
  }: {
    isDeletedChanged: boolean;
    isEditedChanged: boolean;
    isReadByMeChanged: boolean;
    isReadChanged: boolean;
    message: Message;
    unreadMessages?: Message[];
  }) => void;
  "message-synced": ({
    isDeletedChanged,
    isEditedChanged,
    isReadByMeChanged,
    isReadChanged,
    isViewedOnceByMeChanged,
    message,
  }: {
    isDeletedChanged: boolean;
    isEditedChanged: boolean;
    isReadByMeChanged: boolean;
    isReadChanged: boolean;
    isViewedOnceByMeChanged: boolean;
    message: Message;
  }) => void;
  "chat-updated": ({
    addedParticipantsIds,
    removedParticipantsIds,
    chat,
  }: {
    addedParticipantsIds: string[];
    removedParticipantsIds: string[];
    chat: Chat;
  }) => void;
  "chat-synced": (chat: Chat) => void;
}

export const socket: Socket<ServerToClientEvents> = io(env.NEXT_PUBLIC_BACKEND_API, {
  autoConnect: false,
});

export const connectChatSocket = () => {
  socket.io.opts.extraHeaders = {
    authorization: `Bearer ${CookiesService.getAccessToken()}`,
  };
  socket.connect();
};
